<template>
  <Transition name="modal-fade">
    <RiskProfileModal v-if="showRiskModal" @cancel="showRiskModal = false" :open="showRiskModal"/>
  </Transition>
  <Breadcrumb></Breadcrumb>
  <PhysicalPersonForm :physicalPerson="physicalPerson" :title="$gettext('Nouveau client')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import { useRouter } from "vue-router";
import PhysicalPersonForm from "@/components/physical-persons/PhysicalPersonForm.vue";
import { usePhysicalPersonStore } from "@/stores/physicalPerson";
import RiskProfileModal from "@/components/risk-scorings/RiskProfileModal.vue";
import { ref } from "vue";

const router = useRouter();
const physicalPersonStore = usePhysicalPersonStore();
const physicalPerson = physicalPersonStore.emptyPerson;
const showRiskModal = ref(false);

const onSubmit = (payload, actions) => {
  physicalPersonStore.savePhysicalPerson(payload, (physicalPerson) => {
    showRiskModal.value = true;
    waitForRiskScoring(physicalPerson.id);
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const waitForRiskScoring = async (physicalPersonId) => {
  const interval = setInterval(async () => {
    // Need to do a real check for risk scoring completion
    clearInterval(interval);
    showRiskModal.value = false;
    router.push({ name: "physical-person", params: { id: physicalPersonId } });
  }, 3000);
  setTimeout(() => {
    clearInterval(interval);
  }, 60000); // Stop checking after 1 minute
};

const onCancel = () => {
  router.back();
};

</script>
